import Component from '../../../scripts/utilities/component';

class ContentToggle extends Component {
    componentDidMount() {
        this.toggleLink = [...this.root.querySelectorAll('[data-ref="toggler"]')];
        this.togglePanel = [...this.root.querySelectorAll('[data-ref="panel"]')];

        // Set link within panels tabindex to 0 so when using keyboard tabbing,
        // user does not tab inside hidden panel
        this.togglePanel.forEach((panel) => {
            const allLinks = [...panel.getElementsByTagName('a')];

            allLinks.forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
        });

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.toggleLink.forEach((link) => {
            link.addEventListener('click', this.toggleContent.bind(this));
        });
    }

    toggleContent(e) {
        e.preventDefault();
        const elm = e.currentTarget;
        const targetPanel = elm.getAttribute('data-target-panel');
        const thePanel = this.root.querySelector(`[data-panel="${targetPanel}"]`);
        const allLinks = [...thePanel.getElementsByTagName('a')];

        elm.classList.toggle('is--open');
        thePanel.classList.toggle('is--open');

        if (thePanel.classList.contains('is--open')) {
            allLinks.forEach((link) => {
                link.setAttribute('tabindex', '0');
            });
        } else {
            allLinks.forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
        }
    }
}

export default ContentToggle;



// WEBPACK FOOTER //
// ./components/eng-ms-content-toggle/scripts/content-toggle.js